import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import RadioButton from '../common/RadioGroup/RadioButton';
import { WizardInteractionEventPayload } from '../../types/GA4Events/WizardEventParams';
import trackWizardEvent, { createWizardEventPayload } from '../../utils/GA4EventHelpers/trackWizardEvent';

interface ConfirmDeleteWizardProps {
    setConfirmImport: (value: "question" | "import" | "new") => void;
    setShowWarningModal: (value: boolean) => void;
}

export default function ConfirmDeleteWizard(props: ConfirmDeleteWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const handleSelection = (value: boolean) => {
        const wizardEventPayload: WizardInteractionEventPayload = createWizardEventPayload({
            wizard_type: "multires",
            wizard_interaction_type: "start",
            wizard_import_decision: value === true ? "accepted" : "declined",
            wizard_step: 1
        })
        trackWizardEvent(wizardEventPayload)

        if (value) {
            props.setConfirmImport("import")
        } else {
            props.setShowWarningModal(true);
        }
    }
    return (<div>
        <div className='wizard-radio-cell wizard-question'>
            <fieldset>
                <legend>{t("multires-wizard.confirm-delete")}</legend>
                <RadioButton name="confirm-delete-question" id="confirm-delete-question-yes" text={t("yes")} textPosition='right' value="true" currentValue="" onChange={() => handleSelection(true)} testid='wizard-confirm-delete-yes' />
                <RadioButton name="confirm-delete-question" id="confirm-delete-question-no" text={t("no")} textPosition='right' value="false" currentValue="" onChange={() => handleSelection(false)} testid='wizard-confirm-delete-no' />
            </fieldset>
        </div>
    </div>)
}